import 'regenerator-runtime/runtime';
import { productDetail } from './building-blocks/product-detail/product-detail.module';
import { eCatalogTile } from './building-blocks/tiles/e-catalog-tile/e-catalog-tile.module';
import { wishList } from './building-blocks/wish-list/wish-list.module';
import { shoppingCart } from './building-blocks/shopping-cart/shopping-cart.module';
import { eCatalog } from './building-blocks/e-catalog/e-catalog.module';
import { resourceTile } from './building-blocks/tiles/resource-tile/resource-tile.module';
import { ecatalogCheckout } from './components/ecatalog-checkout/ecatalog-checkout.module';
import { selectWishListOverlay } from "./building-blocks/overlays/e-catalog-overlays/select-wish-list-overlay.module";
import { header } from './building-blocks/header/header.module';
import { filter } from './building-blocks/filter/filter.module';

export { wishList } from './building-blocks/wish-list/wish-list.module';
export { shoppingCart } from './building-blocks/shopping-cart/shopping-cart.module';

const initializeAllComponentsEcatalog = (observe): void => {
    eCatalog.initializeAll(observe);
    eCatalogTile.initializeAll(observe);
    productDetail.initializeAll(observe);
    resourceTile.initializeAll(observe);
    wishList.initializeAll(observe);
    shoppingCart.initializeAll(observe);
    ecatalogCheckout.initializeAll(observe);
    header.initializeAll(observe);
    filter.initializeAll(observe);

    // Add listener for select wish list overlay
    selectWishListOverlay.setup();
};

/**
 * Waits for document content loaded event and initializes all javascript controls.
 */
document.addEventListener('DOMContentLoaded', () => {
    if (!document.body.getAttribute('data-ecatalog-initialized')) {
        initializeAllComponentsEcatalog(true);
        document.body.setAttribute('data-ecatalog-initialized', 'true');
    }
});
